import { render, staticRenderFns } from "./IgnoreDomainModal.vue?vue&type=template&id=492b2b29&scoped=true"
import script from "./IgnoreDomainModal.vue?vue&type=script&lang=js"
export * from "./IgnoreDomainModal.vue?vue&type=script&lang=js"
import style0 from "./IgnoreDomainModal.vue?vue&type=style&index=0&id=492b2b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492b2b29",
  null
  
)

export default component.exports